// Module
var code = " <gh-notification-item *ngFor=\"let item of items\" [item]=\"item\"></gh-notification-item>";
// Exports
module.exports = code;